module.exports = __webpack_public_path__ + "assets/loginBackground.jpg";